(function () {
    'use strict';

    angular
        .module('app.resources')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'resources',
                config: {
                    url: '/resources',
                    title: 'Dil Kaynakları',
                    abstract: true,
                    templateUrl: 'app/resources/resources.html'
                }
            },
            {
                state: 'resources.list',
                config: {
                    templateUrl: 'app/resources/resources.list.html',
                    controller: 'ResourcesController',
                    controllerAs: 'vm',
                    url: '/resources',
                    title: 'Dil Kaynakları',
                    settings: {
                        nav: 4,
                        name: 'resources.list',
                        topName: 'system',
                        content: 'Dil Kaynakları',
                        resource: 'menu.resources'
                    }
                }
            }
        ];
    }
})();